<!-- <p>dashboard-flagged-assets works!</p> -->
<div class="watchlist-container">
    <div class="flag-item">
        <span>Asset</span>
        <span>Comment</span>
        <span>Added By</span>
    </div>
    <ejs-listview [dataSource]='flaggedAssets' [fields]="fields" cssClass='e-list-template'>
        <ng-template #template let-data>
            <div title="Click to go to Flagged Assets" *ngIf="flaggedAssets" class="alignRow flag-item app-icon--goto" (click)="goToFlagged(data)">
                <span matTooltipPosition="right">{{ data.Name }} - {{ data.Description }}</span>
                <span>{{data.Comment}}</span>
                <span>{{data.AddedByName}}</span>
                <mat-icon matTooltip="Go to Functional Location" (click)="goToFunctionalLocation(data)"/>
            </div>
        </ng-template>
    </ejs-listview>
</div>